import { render, staticRenderFns } from "./TabTwo.vue?vue&type=template&id=43deee07&scoped=true"
import script from "./TabTwo.vue?vue&type=script&lang=js"
export * from "./TabTwo.vue?vue&type=script&lang=js"
import style0 from "./TabTwo.vue?vue&type=style&index=0&id=43deee07&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43deee07",
  null
  
)

export default component.exports